// src/features/executive/sales/SalesTab.tsx
import { useTranslation } from 'react-i18next'
import SectionHeader from 'features/executive/components/SectionHeader/SectionHeader'
import TopProceduresCard from './widgets/TopProceduresCard'
import TopDoctorsCard from './widgets/TopDoctorsCard'
import TopProductsCard from './widgets/TopProductsCard'
import CategoryMixCard from './widgets/CategoryMixCard'
import SalesSummaryTiles from './widgets/SalesSummaryTiles'
import PaymentMethodMixCard from './widgets/PaymentMethodMixCard'
import { HeroRow, Row, Section, TabRoot } from './usedStyle'

export default function SalesTab() {
  const { t } = useTranslation()
  return (
    <TabRoot>
      {/* Section 1: Sales summary — top-line KPIs */}
      <Section>
        <SectionHeader
          label={t('EXECUTIVE.SALES.SECTION.SUMMARY')}
          caption={t('EXECUTIVE.SALES.SECTION.SUMMARY_CAPTION')}
        />
        <HeroRow>
          <SalesSummaryTiles />
        </HeroRow>
      </Section>

      {/* Section 2: Top performers — what / who is driving sales */}
      <Section>
        <SectionHeader
          label={t('EXECUTIVE.SALES.SECTION.TOP_PERFORMERS')}
          caption={t('EXECUTIVE.SALES.SECTION.TOP_PERFORMERS_CAPTION')}
        />
        <Row>
          <TopProceduresCard />
          <TopDoctorsCard />
        </Row>
        <TopProductsCard />
      </Section>

      {/* Section 3: Mix analysis — composition of revenue & payments */}
      <Section>
        <SectionHeader
          label={t('EXECUTIVE.SALES.SECTION.MIX')}
          caption={t('EXECUTIVE.SALES.SECTION.MIX_CAPTION')}
        />
        <Row>
          <CategoryMixCard />
          <PaymentMethodMixCard />
        </Row>
      </Section>
    </TabRoot>
  )
}
